class CellphoneFormatter {
  // Accepts a string or a integer as a param
  format(cellphone) {
    if (!cellphone) {
      return '';
    }
    let phone = cellphone;
    if (this.isInteger(phone)) {
      phone = cellphone.toString();
    }
    phone = this.removeNonNumbersChars(phone);
    phone = this.addParenthesis(phone);
    return this.addDash(phone);
  }

  addDash(cellphone) {
    // Getting the last 4 digits of the cellphone and spliting to add the dash in the middle
    return `${cellphone.substring(0, cellphone.length - 4)}-${cellphone.substring(cellphone.length - 4)}`;
  }

  addParenthesis(cellphone) {
    if (cellphone.length === 13) {
      return `(${cellphone.substring(2, 4)}) ${cellphone.substring(4)}`;
    } if (cellphone.length === 10 || cellphone.length === 11) {
      // Getting the first two digits of the string and adding the parenthesis around them
      return `(${cellphone.substring(0, 2)}) ${cellphone.substring(2)}`;
    }
    return cellphone;
  }

  removeNonNumbersChars(cellphone) {
    return cellphone.replace(/\D/g, '');
  }

  isInteger(cellphone) {
    return typeof cellphone === 'number';
  }
}

export default new CellphoneFormatter();
